/**
 * created by lei lei on 2020/5/26
 */
import React, {Component,PureComponent} from 'react';
import { Layout,Button,message,Affix ,Icon} from 'antd';
import { WidthProvider, Responsive } from "react-grid-layout";
import _ from "lodash";
import ReactEcharts from 'echarts-for-react';
import { getBarChart,getLineChart,getPieChart,getCategory,getCategory1 } from "./chart";
import './myDesktop.css'
import ActivityPendingComponents from './components/activityPending/ActivityPendingComponents'
import ActivityTrendsComponents from "./components/activityTrends/ActivityTrendsComponents";
import TopicSubmissionReminderComponents from "./components/activityTrends/TopicSubmissionReminderComponents";
import ActivityCompletionComponents from "./components/activityCompletion/ActivityCompletionComponents";
import ResourceStaticComponents from "./components/resourceStatic/ResourceStaticComponents";
import PublishRankingsComponents from "./components/publishRank/PublishRankingsComponents";
import ActivityPendingComponentsOther from "./components/activityPending/ActivityPendingComponentsOther";
import ActivityRankingComponents from "./components/activityRanking/ActivityRankingComponents"
import Shortcuts from './components/shortcuts/Shortcuts'
import FollowUpCorrespondenceComponents from "./components/activityTrends/FollowUpCorrespondenceComponents";
import MyMessage from "./components/myMessage/MyMessage"
import {NAVIGATE_CLOSE, NAVIGATE_OPEN} from "../../constants";
import {connect} from "react-redux";
import {changeNavigateStauts, shrinNavigateStauts, updateNavigateLevel2Data} from "../../actions";
import {uuid} from "../../utils";
import BaseCustomInterface from'../common/BaseCustomInterface'
const ResponsiveReactGridLayout = WidthProvider(Responsive);
const { Header, Content} = Layout;
let that
 class MyDesk extends BaseCustomInterface {
    static defaultProps = {
        cols: { lg:7, md: 7, sm: 7, xs: 4, xxs: 2 },
       // cols: { lg:12, md: 10, sm: 6, xs: 4, xxs: 2 },
        rowHeight: 100,
    };
    constructor(props) {
        super(props);
      
        this.state = {
            layouts: /*this.getFromLS("layouts") ||*/ {},
            widgets:[],
            isResizable:false,//是否可拖动改变大小  // this.showBtnStatus 继承基类的，必须这么写
            isDraggable:false, //是否可拖动
            deleteStatus:false,//是否可删除
            screenChange:false
        }
        this.resize.bind(this);
        that=this
    }

    componentWillMount() {
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize);
    }
     componentWillUnmount() {
         window.removeEventListener('resize',this.resize);
     }

     resize() {
         that.setState({
             screenChange: true
         })

     }


     render() {
        let menuWidth = parseInt(NAVIGATE_OPEN);
        let key=1
         if(this.state.screenChange){
             key=uuid()
         }
         if(!this.props.navigateStatus)
         {
             menuWidth = parseInt(NAVIGATE_CLOSE);
             key=2
         }else {
             key=1
         }

        let dialogWidth = parseInt(window.$(window).width());
        let contentWidth=(dialogWidth-menuWidth)
        let height=window.innerHeight-70
         console.log(contentWidth)
         //定义按钮以后按照这个格式去写
         const btnList=[
             {
                 title:'快捷方式',
                 key:'Shortcuts'
             }, {
                 title:'待处理活动选题',
                 key:'ActivityPendingComponents'
             }, {
                 title:'稿件追踪',
                 key:'FollowUpCorrespondenceComponents'
             }, {
                 title:'活动完成情况',
                 key:'ActivityCompletionComponents'
             }, {
                 title:'活动完成排名',
                 key:'ActivityRankingComponents'
             }, {
                 title:'报送选题提醒',
                 key:'TopicSubmissionReminderComponents'
             }, {
                 title:'其他待我处理',
                 key:'ActivityPendingComponentsOther'
             }, {
                 title:'活动选题动态',
                 key:'ActivityTrendsComponents'
             }, {
                 title:'资源统计',
                 key:'ResourceStaticComponents'
             }, {
                 title:'发布排行',
                 key:'PublishRankingsComponents'
             }, {
                 title:'我的消息',
                 key:'MyMessage'
             },
         ]
         //定义状态通用 封装后的
         this.state.isResizable=this.showBtnStatus
         this.state.isDraggable=this.showBtnStatus
          this.state.deleteStatus=this.showBtnStatus
        return (
            <div key={key} style={{width:contentWidth,height:height,overflowY:'scroll',position:'relative'/*background:"#f2f2f2",padding: 10*/}}>
              {this.renderRightBtn()}
                {this.renderCommonBtn(btnList)}
            <Layout className={'myDsk'} style={{width:'100%'}}>
                    <div style={{ background: '#f2f2f2',  width:'100%'}}>
                        <ResponsiveReactGridLayout
                          width={1000}
                            className="layout"
                          autoSize={true}
                        /*compactType={'horizontal'}*/
                          containerPadding={[20,20]}
                          cols={7}
                            {...this.props}
                            isResizable={this.state.isResizable}
                            isDraggable={this.state.isDraggable}
                            layouts={this.state.layouts}
                            onLayoutChange={(layout, layouts) =>
                                this.onLayoutChange(layout, layouts)
                            }
                        >
                            {this.generateDOM()}
                        </ResponsiveReactGridLayout>
                    </div>
           </Layout>
            </div>
        )
    }
    saveToLS(key, value) {
    }

    generateDOM = () => {
        return _.map(this.state.widgets, (l, i) => {
          /*  console.log(l,i)*/
            l.type=l.i
            let option;
            let type=l.type
            let component
            switch (type) {
                /*left 部分*/
                case 'Shortcuts':
                    component=<Shortcuts/>
                    break;
                case 'ActivityPendingComponents':
                    component=<ActivityPendingComponents/>
                    break;
                case 'FollowUpCorrespondenceComponents':
                    component=<FollowUpCorrespondenceComponents/>
                    break;
                case 'ActivityCompletionComponents':
                    component=<ActivityCompletionComponents/>
                    break;
                case 'ActivityRankingComponents':
                    component=<ActivityRankingComponents/>
                    break;
                case 'TopicSubmissionReminderComponents':
                    component=<TopicSubmissionReminderComponents/>
                    break;
                   /* right 部分*/
                case 'ActivityPendingComponentsOther':
                    component=<ActivityPendingComponentsOther/>
                    break;
                case 'ActivityTrendsComponents':
                    component=<ActivityTrendsComponents/>
                    break;
                case 'ResourceStaticComponents':
                    component=<ResourceStaticComponents/>
                    break;
                case 'PublishRankingsComponents':
                    component=<PublishRankingsComponents/>
                    break;
                case 'MyMessage':
                    component=<MyMessage/>
                    break;

            }
            return (
                <div key={l.i}  data-grid={l}>
                    {
                        this.state.deleteStatus? <span className='remove' onClick={()=>this.onRemoveItem(i)}>x</span>:null
                    }
                    <div key={uuid()}>
                        {component}
                    </div>

                </div>
            );
        });
    };
    addChart(type) {
        let flagAdd=true
        this.state.widgets.forEach((item,i)=>{
            console.log(item)
            if (item.i===type){
                flagAdd=false
                return    message.success('小编您的自定义，桌面已存在，请不要重复添加哦！')

            }
            })

        if(!flagAdd){
            return
        }
            /*定义自定义桌面起始高度*/
        let addItem
        switch (type) {
            /*left 部分*/
            case 'Shortcuts':
                addItem = {
                    x: (this.state.widgets.length * 4) % (7),//组件在x轴坐标
                    // x: (this.state.widgets.length * 4) % (12),//组件在x轴坐标
                    // x: (this.state.widgets.length ) % (4),//组件在x轴坐标
                    y: Infinity, // puts it at the bottom组件在y轴坐标
                    w: 4,// 组件宽度
                    h: 2, //组件高度
                    i: type,//组件标识
                     minW:3,//组件最小宽度   下面四个属性限制最小最大的网格数
                     minH:2,//组件最小高度
                     maxW:7,//组件最大宽度
                     maxH:2,//组件最大高度限制
                };
                break;
            case 'ActivityPendingComponents':
                addItem = {
                    x: 0,//组件在x轴坐标
                    y: 2, // puts it at the bottom组件在y轴坐标
                    w: 4,// 组件宽度
                    h: 3, //组件高度
                    i: type,//组件标识
                    minW:3,//组件最小宽度   下面四个属性限制最小最大的网格数
                    minH:3,//组件最小高度
                    maxW:7,//组件最大宽度
                    maxH:3,//组件最大高度限制
                };
                break;
            case 'FollowUpCorrespondenceComponents':
                addItem = {
                    x: 0,//组件在x轴坐标
                    y: 5, // puts it at the bottom组件在y轴坐标
                    w: 4,// 组件宽度
                    h: 6, //组件高度
                    i: type,//组件标识
                    minW:3,//组件最小宽度   下面四个属性限制最小最大的网格数
                    minH:6,//组件最小高度
                    maxW:7,//组件最大宽度
                    maxH:6,//组件最大高度限制
                };
                break;
            case 'ActivityCompletionComponents':
                addItem = {
                    x: 0,//组件在x轴坐标
                    y: 11, // puts it at the bottom组件在y轴坐标
                    w: 4,// 组件宽度
                    h: 5, //组件高度
                    i: type,//组件标识
                    minW:3,//组件最小宽度   下面四个属性限制最小最大的网格数
                    minH:5,//组件最小高度
                    maxW:7,//组件最大宽度
                    maxH:5,//组件最大高度限制
                };
                break;
            case 'ActivityRankingComponents':
                addItem = {
                    x: 0,//组件在x轴坐标
                    y: 16, // puts it at the bottom组件在y轴坐标
                    w: 4,// 组件宽度
                    h: 4, //组件高度
                    i: type,//组件标识
                    minW:3,//组件最小宽度   下面四个属性限制最小最大的网格数
                    minH:4,//组件最小高度
                    maxW:7,//组件最大宽度
                    maxH:4,//组件最大高度限制
                };
                break;
            case 'TopicSubmissionReminderComponents':
                addItem = {
                    x: 0,//组件在x轴坐标
                    y: 21, // puts it at the bottom组件在y轴坐标
                    w: 4,// 组件宽度
                    h: 6, //组件高度
                    i: type,//组件标识
                    minW:3,//组件最小宽度   下面四个属性限制最小最大的网格数
                    minH:6,//组件最小高度
                    maxW:7,//组件最大宽度
                    maxH:6,//组件最大高度限制
                };
                break;
            /* right 部分*/
            case 'ActivityPendingComponentsOther':
                addItem = {
                    x: 4,//组件在x轴坐标
                    y:0, // puts it at the bottom组件在y轴坐标
                    w: 3,// 组件宽度
                    h: 5, //组件高度
                    i: type,//组件标识
                    minW:3,//组件最小宽度   下面四个属性限制最小最大的网格数
                    minH:5,//组件最小高度
                    maxW:7,//组件最大宽度
                    maxH:5,//组件最大高度限制
                };
                break;
            case 'ActivityTrendsComponents':
                addItem = {
                    x: 4,//组件在x轴坐标
                    y: 5, // puts it at the bottom组件在y轴坐标
                    w: 3,// 组件宽度
                    h: 4, //组件高度
                    i: type,//组件标识
                    minW:3,//组件最小宽度   下面四个属性限制最小最大的网格数
                    minH:4,//组件最小高度
                    maxW:7,//组件最大宽度
                    maxH:4,//组件最大高度限制
                };
                break;
            case 'ResourceStaticComponents':
                addItem = {
                    x: 4,//组件在x轴坐标
                    y: 9, // puts it at the bottom组件在y轴坐标
                    w: 3,// 组件宽度
                    h: 4, //组件高度
                    i: type,//组件标识
                    minW:3,//组件最小宽度   下面四个属性限制最小最大的网格数
                    minH:4,//组件最小高度
                    maxW:7,//组件最大宽度
                    maxH:4,//组件最大高度限制
                };
                break;
            case 'PublishRankingsComponents':
                addItem = {
                    x: 4,//组件在x轴坐标
                    y: 13, // puts it at the bottom组件在y轴坐标
                    w: 3,// 组件宽度
                    h: 6, //组件高度
                    i: type,//组件标识
                    minW:3,//组件最小宽度   下面四个属性限制最小最大的网格数
                    minH:6,//组件最小高度
                    maxW:7,//组件最大宽度
                    maxH:6,//组件最大高度限制
                };
                break;
            case 'MyMessage':
                addItem = {
                    x: 4,//组件在x轴坐标
                    y: 19, // puts it at the bottom组件在y轴坐标
                    w: 3,// 组件宽度
                    h: 6, //组件高度
                    i: type,//组件标识
                    minW:3,//组件最小宽度   下面四个属性限制最小最大的网格数
                    minH:6,//组件最小高度
                    maxW:7,//组件最大宽度
                    maxH:6,//组件最大高度限制
                };
                break;
        }


        this.setState(
            {
                widgets: this.state.widgets.concat({
                    ...addItem,
                    type,
                }),
            },
        );
    };

     onRemoveItem(i) {
         console.log(this.state.widgets)
         this.setState({
             widgets: this.state.widgets.filter((item, index) => index != i)
         });

     }


    onLayoutChange(layout, layouts) {
     /*   console.log('layout',layout,'layouts', layouts)*/
        this.saveToLS("layouts", layouts);
        this.setState({ layouts });
    }

}
function mapStateToProps(state){
    return {
        navigateStatus:state.systemReducer.navigateStatus,
    }
}
function mapStateToMethod(dispatch) {
    return {
        shrinNavigateStauts: function () {
            return dispatch(shrinNavigateStauts());
        }

    }
}
export default connect(mapStateToProps, mapStateToMethod)(MyDesk);